import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import {
  Article,
  ArticleBrandId,
  ArticleCategory,
  ArticleGroupIds,
} from "../types";
import { ArticlesDB } from "./Articles";

export const getArticleDetails = async (
  brandId: ArticleBrandId,
  categoryId: ArticleCategory,
  groupId: ArticleGroupIds,
  articleId: string,
): Promise<Article> => {
  const collectionRef = collection(
    db,
    "legalDocuments",
    brandId,
    categoryId,
    groupId,
    "documents",
  );

  const articlesSnapshot = await getDoc(doc(collectionRef, articleId));

  return new ArticlesDB(articlesSnapshot).toArticle();
};
